export default __webpack_public_path__ + "static/media/opensans-bolditalic-webfont.89d128e1.woff";